import { Box, Typography } from '@mui/material';

export const Instruction = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      m={2}
      p={3}
      sx={(theme) => ({
        backgroundColor: theme.palette.grey[100],
        borderRadius: theme.spacing(1),
      })}
    >
      <Typography textAlign="center">{children}</Typography>
    </Box>
  );
};
